function proxyVariant(proxyVariantElementId, value)
{
  	var element = document.getElementById(proxyVariantElementId);
  	element.value = value;
 	element.onchange(); 
}

function selectMetal(metalType, spanReference, proxyVariantElementId, proxyVariantElementValue)
{
  	var metalRadioButtons = ["silvermetal", "goldmetal", "rosegoldmetal", "puregoldmetal"];
  	var metalButtonsId = ['silver', 'gold', 'rose', 'puregold'];
  	for(var i=0; i<metalRadioButtons.length; i++)
    {
      	document.getElementById(metalRadioButtons[i]).className = "metal-selection";
      	document.getElementById(metalButtonsId[i]).className = "hide-text";
    }
	var metalRadioButtonElement =  document.getElementById(metalType);
  	metalRadioButtonElement.className = "metal-selection metal-active";
  	var metalButtonsId =  document.getElementById(spanReference);
    metalButtonsId.className = "show-text";
  	document.getElementById("select-metal").style.display = "inline";
  
	var proxyVariantElement = document.getElementById(proxyVariantElementId);
    proxyVariantElement.value = proxyVariantElementValue;
    proxyVariantElement.onchange(); 
    
	setTimeout(drawInputText, 25);
}

function populateDeliverDate()
{
  if(document.getElementById("estimatedDeliveryDate"))
  {
    	var minDaysToDeliver = 5;
    	var maxDaysToDeliver = 10;
    	var minDate = new Date();
    	minDate.setDate(minDate.getDate() + minDaysToDeliver);
    	var maxDate = new Date();
    	maxDate.setDate(maxDate.getDate() + maxDaysToDeliver);
    
    
    	var weekdayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
   		var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    	var formattedMinDate = weekdayNames[minDate.getDay()] + " " + monthNames[minDate.getMonth()] + " " + minDate.getDate();
    	var formattedMaxDate = weekdayNames[maxDate.getDay()] + " " + monthNames[maxDate.getMonth()] + " " + maxDate.getDate();
    
    	document.getElementById("estimatedDeliveryDate").innerHTML = "<center>Estimated delivery <b>"+formattedMinDate+" - "+formattedMaxDate+"</b></center>";
  }
}



//####### RENDERING #######

var isAdmin;
var textCanvas;
var textContext;
var charCanvas;
var charContext;
var canvasFontStyle = "bold 72px";
var canvasFontSize;
var canvasFontName = "";
var canvasFont = "";
var drawnText = "";
var canvasFontColor = "#000000";//"#999999";
var overlay;
var overlaySource = "//rachelrothjewelry.com/cdn/shop/t/15/assets/watermark.png?v=13967017210707123011790550100";
var overlayAlpha = 0.0;
var loopInnerRadius = 3;
var loopOuterRadius = 7;
var isWindowLoaded = false;
var materialImageGold;
var materialImageRoseGold;
var materialImageSilver;
var jewelryMaterial;
var savedCanvasData = {};
var isDraggingCharm = false;
var isRotatingCharm = false;
var isCharmSelected = false;
var charm;
var shiftIsHeld = false;
var rotateStartX, rotateStartY;
var isCharmEnabled = false;

/*
 * Render a string to the canvas as jewelry
 */
function renderTextPreview(text)
{
    textContext.clearRect(0, 0, textCanvas.width, textCanvas.height);
    text = text.split(/[\W\s_]/).join("");
    if (text == '') return true;
    // only allow letters and numbers
    if (new RegExp(/[\W_]/).exec(text)) return false;
    drawnText = text;
    var runningWidth = 0; // width of the string as we build it
    var charShift = 0;
    var charBoundingBox;
    var startBoundingBoxSearchOnRight = false;
    var x = 0;
    var y = textCanvas.height / 2;
    var top = textCanvas.height;
    var bottom = 0;
    textContext.font = canvasFont;
    // draw the string one letter at a time to make the letters touch
    for (var i = 0; i < text.length; ++i)
    {
        charBoundingBox = getCharacterBoundingBox(text[i], startBoundingBoxSearchOnRight, 50, 100, 0, 0, 200, 200);
        if (i == 0)
        {
            firstCharBox = charBoundingBox;
            startBoundingBoxSearchOnRight = true;
        }
        else
        {
            charShift = getCharacterShift(text[i - 1], text[i], availableFonts[canvasFontName]['overlapThreshold']);
        }
        if (charBoundingBox['top'] < top)
        {
            top = charBoundingBox['top'];    
        }
        if (charBoundingBox['bottom'] > bottom)
        {
            bottom = charBoundingBox['bottom'];    
        }
        textContext.fillStyle = canvasFontColor;
        textContext.fillText(text[i], x + runningWidth - charBoundingBox['left'] + charShift, y);
        runningWidth += charBoundingBox['right'] - charBoundingBox['left'] + charShift;
        prevCharBox = charBoundingBox;
    }
    var image = textContext.getImageData(0, 0, textCanvas.width, textCanvas.height);
    textContext.clearRect(0, 0, textCanvas.width, textCanvas.height);
    // center the string on the canvas
    x = textCanvas.width / 2 - runningWidth / 2;
    y = -top + (top - bottom) / 2;
    textContext.putImageData(image,x, y);
    savedCanvasData["text"] = textContext.getImageData(0, 0, textCanvas.width, textCanvas.height);
    var loops = addLoops(firstCharBox, charBoundingBox, textCanvas.width / 2 - runningWidth / 2, textCanvas.height / 2 + y, runningWidth, charShift);
    savedCanvasData["loops"] = loops;
    if (Object.keys(savedCanvasData).includes('charm') && savedCanvasData.charm != {})
    {
        drawCharm(savedCanvasData.charm.x, savedCanvasData.charm.y, savedCanvasData.charm.angle);    
    }
    if (!isAdmin)
    {
        drawMaterialWithEffects(textCanvas, getMaterial());
        textContext.globalAlpha = overlayAlpha;
        textContext.drawImage(overlay, 0, 0, textCanvas.width, textCanvas.height);  
        textContext.globalAlpha = 1.0;  
    }
    return true;
}

function redrawCanvas()
{
    textContext.clearRect(0, 0, textContext.width, textContext.height);
    textContext.putImageData(savedCanvasData["text"], 0, 0);
    if (Object.keys(savedCanvasData).includes("charm") && savedCanvasData.charm != {})
    {
        drawCharm(savedCanvasData.charm.x, savedCanvasData.charm.y, savedCanvasData.charm.angle);
    }
    drawLoop(textCanvas, savedCanvasData.loops.left.x, savedCanvasData.loops.left.y, loopInnerRadius, loopOuterRadius);
    drawLoop(textCanvas, savedCanvasData.loops.right.x, savedCanvasData.loops.right.y, loopInnerRadius, loopOuterRadius);
    if (!isAdmin)
    {
        drawMaterialWithEffects(textCanvas, getMaterial());
    }
    if (Object.keys(savedCanvasData).includes("charm") && savedCanvasData.charm != {} && isCharmSelected)
    {
        // Has to be done after the materials are added
        drawCharmCircle();
    }
}

/*
 * Get the relatively positioned bounding box of a character
 */ 
var memoizedCharacterBoundingBox = {};
function getCharacterBoundingBox(char, fromRight = false, drawX = false, drawY = false, searchLeft = -200, searchTop = -200, searchWidth = 600, searchHeight = 600)
{
  	var cacheKey = char+fromRight+drawX+drawY+searchLeft+searchTop+searchWidth+searchHeight+canvasFontName;
	if(memoizedCharacterBoundingBox[cacheKey]) return memoizedCharacterBoundingBox[cacheKey];
  	
	if(!drawX) drawX = 50 + canvasFontSize;
    if(!drawY) drawY = 50 + canvasFontSize;
    charContext.font = canvasFont;
    charContext.fillStyle = "#FFFFFF";
    charContext.fillRect(searchLeft - 20, searchTop - 20, searchWidth + 40, searchHeight + 40);
    charContext.fillStyle = '#000000';
    charContext.fillText(char, drawX, drawY);
    var box = getBoundingBox(charContext, searchLeft, searchTop, searchWidth, searchHeight, fromRight);
    box['left'] -= drawX;
    box['right'] -= drawX;
    box['top'] -= drawY;
    box['bottom'] -= drawY;
    box['firstX'] -= drawX;
    box['firstY'] -= drawY;
    box['topLeftPixel'][0] -= drawX;
    box['topLeftPixel'][1] -= drawY;
    box['topRightPixel'][0] -= drawX;
    box['topRightPixel'][1] -= drawY;
    box['character'] = char;
  	memoizedCharacterBoundingBox[cacheKey] = box;
    return box;
}

/*
 * Get the absolutely positioned bounding box of a drawing on a canvas
 */
function getBoundingBox(context, searchLeft, searchTop, searchWidth, searchHeight, fromRight = false)
{
    var imageData = context.getImageData(searchLeft, searchTop, searchWidth, searchHeight).data;
    var i, color, alpha;
    var top = 9999999;
    var bottom = 0;
    var left = 9999999;
    var right = 0;
    var totalPixels = 0;
    var distanceToTopLeft, distanceToTopRight;
    var minDistanceToTopLeft = 9999999;
    var minDistanceToTopRight = 9999999;
    var topLeftPixelX, topLeftPixelY;
    var topRightPixelX, topRightPixelY;
    // the y-axis is weighted heavier in distance calculations so loops tend to be placed near the tops of letters
    var xAxisWeight = 1;
    var yAxisWeight = 2;
    var firstPixelFound = false;
    var firstX, firstY;
    var xStart, xDirection;
    if (fromRight) {
        xStart = searchWidth - 1;
        xDirection = -1;
    }
    else
    {
        xStart = 0;
        xDirection = 1;
    }
    for (var y = 0; y < searchHeight; ++y)
    {
        for (var x = xStart; x < searchWidth && x >= 0; x += xDirection)
        {
            i = 4 * (y * searchWidth + x);
            color = imageData[i] + imageData[i + 1] + imageData[i + 2];
            alpha = imageData[i + 3];
            if (color < 765 && alpha > 100)
            {
                ++totalPixels;
                if (!firstPixelFound)
                {
                    firstX = x;
                    firstY = y;
                    firstPixelFound = true;
                }
                distanceToTopLeft = Math.sqrt(Math.pow(x * xAxisWeight, 2) + Math.pow(y * yAxisWeight, 2));
                distanceToTopRight = Math.sqrt(Math.pow((searchWidth - x) * xAxisWeight, 2) + Math.pow(y * yAxisWeight, 2));
                if (distanceToTopLeft < minDistanceToTopLeft)
                {
                    minDistanceToTopLeft = distanceToTopLeft;
                    topLeftPixelX = x;
                    topLeftPixelY = y;
                }
                if (distanceToTopRight < minDistanceToTopRight)
                {
                    minDistanceToTopRight = distanceToTopRight;
                    topRightPixelX = x;
                    topRightPixelY = y;
                }
                if (x > right)
                {
                    right = x;    
                }
                else if (x < left)
                {
                    left = x;    
                }
                if (y > bottom)
                {
                    bottom = y;    
                }
                else if (y < top)
                {
                    top = y;    
                }
            }
        }
    }   
    var size = {
        'pixels': totalPixels,
        'left': left + 1,
        'right': right - 1,
        'top': top + 1,
        'bottom': bottom - 1,
        'width': right - left,
        'height': bottom - top,
        'topLeftPixel': [topLeftPixelX, topLeftPixelY],
        'topRightPixel': [topRightPixelX, topRightPixelY],
        'firstX': firstX,
        'firstY': firstY,
        'fromRight': fromRight
    };
    return size;
}

/*
 * Get the point on the word closest to the origin
 */
function getClosestPointOnWord(context, originX, originY, xAxisWeight, yAxisWeight)
{
    var imageData = context.getImageData(0, 0, context.canvas.width, context.canvas.height).data;
    var i, color, alpha;
    var closestX, closestY;
    var xStart = 0;
    var xDirection = 1;
    var distanceToOrigin;
    var minDistanceToOrigin = 99999;
    for (var y = 0; y < context.canvas.height; ++y)
    {
        for (var x = xStart; x < context.canvas.width && x >= 0; x += xDirection)
        {
            i = 4 * (y * context.canvas.width + x);
            color = imageData[i] + imageData[i + 1] + imageData[i + 2];
            alpha = imageData[i + 3];
            if (color < 765 && alpha > 100)
            {
                distanceToOrigin = Math.sqrt(Math.pow(originX - x * xAxisWeight, 2) + Math.pow(originY - y * yAxisWeight, 2));
                if (distanceToOrigin < minDistanceToOrigin)
                {
                    minDistanceToOrigin = distanceToOrigin;
                    closestX = x;
                    closestY = y;
                }
            }
        }
    }   
    var closestPoint = {
        0: closestX,
        1: closestY,
        'x': closestX,
        'y': closestY,
    };
    return closestPoint;
}

/*
 * Get the distance secondChar must be moved until it overlaps with firstChar by the given amount
 */
var memoizedCharacterShiftData = {};
function getCharacterShift(firstChar, secondChar, overlapThreshold)
{
  	var memoizeObjectCacheKey = firstChar+secondChar+overlapThreshold+canvasFontName;
  	if(memoizedCharacterShiftData[memoizeObjectCacheKey]) return memoizedCharacterShiftData[memoizeObjectCacheKey];
  
    var shiftCanvas = document.getElementById('character-shifting-canvas');
    var shiftContext = shiftCanvas.getContext('2d');
    shiftContext.font = canvasFont;
    var firstCharInfo = getCharacterBoundingBox(firstChar, false);
    var secondCharInfo = getCharacterBoundingBox(secondChar, false);
    var shiftCanvasInfo;
    var shift = 0;
    var overlap = -1;
    var previousOverlap = -1;
    var maxShift = -5000;
    var textX = 100;
    var textY = 100;
    do {
        // shift the second character to the left until enough pixels overlap or a shift results in less overlap
        previousOverlap = overlap;
        shiftContext.fillStyle = "#FFFFFF";
        shiftContext.fillRect(-200, -200, 800, 800);
        shiftContext.fillStyle = '#000000';
        shiftContext.fillText(firstChar, textX, textY);
        shiftContext.fillText(secondChar, textX + firstCharInfo['right'] - secondCharInfo['left'] + shift, textY);
        shiftCanvasInfo = getBoundingBox(shiftContext, 0, 0, 400, 400);
        overlap = firstCharInfo['pixels'] + secondCharInfo['pixels'] - shiftCanvasInfo['pixels'];
        if (overlap < 0)
        {
            // If a letter pair results in a negative overlap, then the characters will not be displayed correctly
            // This probably means that the guesses I made in getCharacterBoundingBox are insufficient and
            // the default values in that function should be changed to ensure the character is entirely in the search area
            return false;
        }
    } while (overlap <= overlapThreshold && overlap >= previousOverlap && --shift > maxShift);
  
	memoizedCharacterShiftData[memoizeObjectCacheKey] = shift;
    return shift;
}

/*
 * Add loops to the top left and right of the string drawn to the canvas
 */
function addLoops(firstCharBox, lastCharBox, textX, textY, textWidth)
{
    var horizontalOffset = loopInnerRadius * 0.75;
    if (lastCharBox['topRightPixel'][1] >= firstCharBox['topLeftPixel'][1])
    {
        // last character is shorter
        var croppedFirstCharBox = getCharacterBoundingBox(firstCharBox['character'], false, -firstCharBox['left'],
                                                          -firstCharBox['top'] - (lastCharBox['topRightPixel'][1] - firstCharBox['top']), 
                                                          0, 0);
        var leftLoopX = croppedFirstCharBox['firstX'] + textX - firstCharBox['left'] - horizontalOffset;
        var leftLoopY = croppedFirstCharBox['firstY'] + textY;
        var rightLoopX = lastCharBox['topRightPixel'][0] + textX + textWidth - (lastCharBox['right']) + horizontalOffset;
        var rightLoopY = lastCharBox['topRightPixel'][1] + textY;
    }
    else
    {
        // first character is shorter
        var croppedLastCharBox = getCharacterBoundingBox(lastCharBox['character'], true, -lastCharBox['left'],
                                                         -lastCharBox['top'] - (firstCharBox['topLeftPixel'][1] - lastCharBox['top']), 
                                                         0, 0, 400, 400);
        var leftLoopX = firstCharBox['topLeftPixel'][0] + textX - firstCharBox['left'] - horizontalOffset;
        var leftLoopY = firstCharBox['topLeftPixel'][1] + textY;
        var rightLoopX = croppedLastCharBox['firstX'] + textX + textWidth - (lastCharBox['right']) + horizontalOffset;
        var rightLoopY = croppedLastCharBox['firstY'] + textY;
    }
    drawLoop(textCanvas, leftLoopX, leftLoopY, loopInnerRadius, loopOuterRadius);
    drawLoop(textCanvas, rightLoopX, rightLoopY, loopInnerRadius, loopOuterRadius);
    return {
        'left': {
            0: leftLoopX,
            1: leftLoopY,
            "x": leftLoopX,
            "y": leftLoopY
        },
        'right': {
            0: rightLoopX,
            1: rightLoopY,
            "x": rightLoopX,
            "y":rightLoopY
        }
    }
}

function drawLoop(canvas, x, y, innerRadius, outerRadius)
{
    var context = canvas.getContext('2d');
    context.beginPath();
    context.strokeStyle = canvasFontColor;
    context.fillStyle = canvasFontColor;
    context.arc(x, y, outerRadius, 0, 2 * Math.PI);
    context.stroke();
    context.fill();

    context.beginPath();
    context.globalCompositeOperation = 'destination-out';
    context.strokeStyle = canvasFontColor;
    context.fillStyle = "#FFFFFF";
    context.arc(x, y, innerRadius, 0, 2 * Math.PI);
    context.stroke();
    context.fill();
    context.globalCompositeOperation = 'source-over';
}

function placeCharm(x, y)
{
    if (!Object.keys(savedCanvasData).includes("charm") && savedCanvasData.charm != {})
    {
        // Initialize charm position values
        savedCanvasData["charm"] = {};
        savedCanvasData.charm.angle = 0;
    }
    savedCanvasData.charm.x = x;
    savedCanvasData.charm.y = y;
    saveCharmPositionToForm();
    redrawCanvas();
}

function drawCharm(x, y, angle)
{
    if (!savedCanvasData.charm || savedCanvasData.charm == {} || !charm || !charm.boundingBox) return;
    textContext.save()
    textContext.fillStyle = "#000000";
    // Translate the canvas, rotate it, draw the charm at (0,0) 
    textContext.translate(x, y);
    textContext.rotate(-angle);
    textContext.drawImage(charm['image'], -charm.boundingBox.width / 2, -charm.boundingBox.height / 2);
    textContext.restore();
}

function pointIsInCharm(x, y)
{
    if (!savedCanvasData.charm || savedCanvasData.charm == {} || !charm || !charm.boundingBox) return;
    var angle = savedCanvasData.charm.angle;
    var left = -charm.boundingBox.width / 2;
    var right = charm.boundingBox.width / 2;
    var top = charm.boundingBox.height / 2;
    var bottom = -charm.boundingBox.height / 2;
    var cx = savedCanvasData.charm.x;
    var cy = savedCanvasData.charm.y;
    var rotatedX = (cx - x) * Math.cos(-angle) - (cy - y) * Math.sin(-angle);
    var rotatedY = (cx - x) * Math.sin(-angle) + (cy - y) * Math.cos(-angle);
    return rotatedX >= left && rotatedX <= right && rotatedY >= bottom && rotatedY <= top;
}

var circlePadding = 8;
function drawCharmCircle()
{
    if (!isCharmEnabled) return;
    var circleRadius = Math.sqrt(Math.pow(charm.boundingBox.width / 2, 2) + Math.pow(charm.boundingBox.height / 2, 2)) + circlePadding;
    var arrowWidth = 6;
    var arrowAngularWidth = 0.20; // "Length" of arrow, in radians
    var circleColor = "#67a9f5";
    textContext.save();
    textContext.strokeStyle = circleColor;
    textContext.lineWidth = 2;

    textContext.beginPath();
    textContext.arc(savedCanvasData.charm.x, savedCanvasData.charm.y, circleRadius, 0, 2 * Math.PI);
    // Draw the two arrows on the circle
    textContext.stroke();
    textContext.beginPath();
    textContext.moveTo(savedCanvasData.charm.x + circleRadius * Math.cos(-savedCanvasData.charm.angle), savedCanvasData.charm.y + circleRadius * Math.sin(-savedCanvasData.charm.angle));
    textContext.lineTo(savedCanvasData.charm.x + (circleRadius + arrowWidth * 0.8) * Math.cos(-savedCanvasData.charm.angle), savedCanvasData.charm.y + (circleRadius + arrowWidth * 0.8) * Math.sin(-savedCanvasData.charm.angle))
    textContext.lineTo(savedCanvasData.charm.x + (circleRadius) * Math.cos(-savedCanvasData.charm.angle + arrowAngularWidth), savedCanvasData.charm.y + (circleRadius) * Math.sin(-savedCanvasData.charm.angle + arrowAngularWidth))
    textContext.lineTo(savedCanvasData.charm.x + (circleRadius - arrowWidth) * Math.cos(-savedCanvasData.charm.angle), savedCanvasData.charm.y + (circleRadius - arrowWidth) * Math.sin(-savedCanvasData.charm.angle))
    textContext.lineTo(savedCanvasData.charm.x + circleRadius * Math.cos(-savedCanvasData.charm.angle), savedCanvasData.charm.y + circleRadius * Math.sin(-savedCanvasData.charm.angle));
    
    textContext.stroke();
    textContext.fillStyle = circleColor;
    textContext.fill();
    textContext.beginPath();
    textContext.moveTo(savedCanvasData.charm.x + circleRadius * Math.cos(-savedCanvasData.charm.angle + Math.PI), savedCanvasData.charm.y + circleRadius * Math.sin(-savedCanvasData.charm.angle + Math.PI));
    textContext.lineTo(savedCanvasData.charm.x + (circleRadius + arrowWidth * 0.8) * Math.cos(-savedCanvasData.charm.angle + Math.PI), savedCanvasData.charm.y + (circleRadius + arrowWidth * 0.8) * Math.sin(-savedCanvasData.charm.angle + Math.PI))
    textContext.lineTo(savedCanvasData.charm.x + (circleRadius) * Math.cos(-savedCanvasData.charm.angle + Math.PI + arrowAngularWidth), savedCanvasData.charm.y + (circleRadius) * Math.sin(-savedCanvasData.charm.angle + Math.PI + arrowAngularWidth))
    textContext.lineTo(savedCanvasData.charm.x + (circleRadius - arrowWidth) * Math.cos(-savedCanvasData.charm.angle + Math.PI), savedCanvasData.charm.y + (circleRadius - arrowWidth) * Math.sin(-savedCanvasData.charm.angle + Math.PI))
    textContext.lineTo(savedCanvasData.charm.x + circleRadius * Math.cos(-savedCanvasData.charm.angle + Math.PI), savedCanvasData.charm.y + circleRadius * Math.sin(-savedCanvasData.charm.angle + Math.PI));
    
    textContext.stroke();
    textContext.fillStyle = circleColor;
    textContext.fill();
    textContext.restore();
    // var circleRadius = Math.sqrt(Math.pow(charm.boundingBox.width / 2, 2) + Math.pow(charm.boundingBox.height / 2, 2)) + circlePadding;
    // var smallCircleRadius = 3;
    // var circleColor = "#67a9f5";
    // textContext.save();
    // textContext.strokeStyle = circleColor;
    // textContext.beginPath();
    // textContext.rect(savedCanvasData.charm.x - charm.boundingBox.width / 2 - circlePadding / 2,
    //     savedCanvasData.charm.y - charm.boundingBox.height / 2 - circlePadding / 2,
    //     charm.boundingBox.width + circlePadding,
    //     charm.boundingBox.height + circlePadding);
    // textContext.stroke();
    // textContext.beginPath();
    // textContext.arc(savedCanvasData.charm.x - charm.boundingBox.width / 2 * Math.cos(-savedCanvasData.charm.angle), savedCanvasData.charm.y - charm.boundingBox.height / 2 + circleRadius  * Math.sin(-savedCanvasData.charm.angle), smallCircleRadius, 0, 2 * Math.PI);
    // textContext.stroke();
    // textContext.fillStyle = circleColor;
    // //textContext.fill();
    // textContext.restore();
}

function distanceToCharmCircle(x, y)
{
    if (!savedCanvasData.charm || savedCanvasData.charm == {} || !charm || !charm.boundingBox) return;
    var circleRadius = Math.sqrt(Math.pow(charm.boundingBox.width / 2, 2) + Math.pow(charm.boundingBox.height / 2, 2)) + circlePadding;
    var distanceToCenter = distance(x, y, savedCanvasData.charm.x, savedCanvasData.charm.y);
    return Math.abs(distanceToCenter - circleRadius);
}

function rotateCharm(cursorX, cursorY)
{
    var initVectorX = rotateStartX - savedCanvasData.charm.x;
    var initVectorY = rotateStartY - savedCanvasData.charm.y;
    var initVectorLength = Math.sqrt(Math.pow(initVectorX, 2) + Math.pow(initVectorY, 2));
    var newVectorX = cursorX - savedCanvasData.charm.x;
    var newVectorY = cursorY - savedCanvasData.charm.y;
    var newVectorLength = Math.sqrt(Math.pow(newVectorX, 2) + Math.pow(newVectorY, 2));
    if (newVectorLength == 0) return;
    // Determine the angle between the last cursor position and the current position, relative to the center of the charm
    var angleDelta = -Math.asin(((initVectorX / initVectorLength) * (newVectorY / newVectorLength)) - ((initVectorY / initVectorLength) * (newVectorX / newVectorLength)));
    if (!shiftIsHeld)
    {
        savedCanvasData.charm.angle += angleDelta;
        rotateStartX = cursorX;
        rotateStartY = cursorY;
    }
    else
    {
        // Round angle to nearest 45 degrees
        if (angleDelta > 0)
        {
            var newAngle = Math.floor((savedCanvasData.charm.angle + angleDelta) * 4 / Math.PI) * Math.PI / 4;
        }
        else
        {
            var newAngle = Math.ceil((savedCanvasData.charm.angle + angleDelta) * 4 / Math.PI) * Math.PI / 4;
        }
        if (savedCanvasData.charm.angle != newAngle)
        {
            rotateStartX = cursorX;
            rotateStartY = cursorY;
        }
        savedCanvasData.charm.angle = newAngle;
    }
    saveCharmPositionToForm();
    redrawCanvas();
}

function setCharmAngle(angle)
{
    savedCanvasData.charm.angle = angle;
    redrawCanvas();
}

/*
 * Write the position of the charm to the product form so it gets passed as a line item property
 */
function saveCharmPositionToForm()
{
    var positionInput = document.getElementById('charm-position');
    var rotationInput = document.getElementById('charm-rotation');
    // Used to remove/add the hidden inputs from the line item properties
    var positionInputStringStart = "<input type='hidden' id='charm-position' name='properties[Shape Position]'";
    var rotationInputStringStart = "<input type='hidden' id='charm-rotation' name='properties[Shape Rotation]'";
    var removedPositionInputString = "<input type='hidden' id='charm-position'>";
    var removedRotationInputString = "<input type='hidden' id='charm-rotation'>";
    if (!positionInput || !rotationInput)
    {
        console.error("Failed to write charm position to hidden inputs");
        return;
    }
    if (isCharmEnabled && savedCanvasData.charm && savedCanvasData.charm != {})
    {
        var positionInputValue = Math.round(10 * savedCanvasData.charm.x)/10 + "," + Math.round(10 * savedCanvasData.charm.y) / 10;
        var rotationInputValue = Math.round(1000 * savedCanvasData.charm.angle) / 1000;
        positionInput.outerHTML = positionInputStringStart + "value='" + positionInputValue + "'>";
        rotationInput.outerHTML = rotationInputStringStart + "value='" + rotationInputValue + "'>";;
    }
    else
    {
        positionInput.outerHTML = removedPositionInputString;
        rotationInput.outerHTML = removedRotationInputString;
    }
}

function loadCharmCoordinates(coordinates)
{
    var coordinates = coordinates.split(',');
    placeCharm(coordinates[0], coordinates[1]);
}

function loadCharm(charmName)
{
    var charmDomElement = document.getElementById('charm');
    var instructionsElement = document.getElementById('shape-instructions');
    if (!Object.keys(charms).includes(charmName))
    {
        isCharmEnabled = false;
        charm = {};
        charmDomElement.innerHTML = "";
        redrawCanvas();
        // Clear the names of the hidden inputs so they don't get passed through on purchase
        saveCharmPositionToForm();
        instructionsElement.innerHTML = "";
        return;
    }
    isCharmEnabled = true;
    charmDomElement.innerHTML = atob(charms[charmName]);
    charm['rawSvg'] = charmDomElement.innerHTML;
    charm['svgObject'] = SVG(charmDomElement);
    var tempBoundingBox = charm['svgObject'].bbox();
    if (tempBoundingBox.width > tempBoundingBox.height)
    {
        charm['displayWidth'] = 38;    
        charm['displayHeight'] = tempBoundingBox.height / (tempBoundingBox.width / charm['displayWidth']);
    }
    else
    {
        charm['displayHeight'] = 38;    
        charm['displayWidth'] = tempBoundingBox.width / (tempBoundingBox.height / charm['displayHeight']);    
    }
    charm['boundingBox'] = transformSvg(charm['svgObject']);
    saveCharmPositionToForm();
    instructionsElement.innerHTML = "<i>Click anywhere on the preview to place your shape</i>";
    charm['image'] = new Image();
    charm['image'].src = "data:image/svg+xml;base64," + btoa(charm.svgObject.svg());
    charm['image'].onload = function ()
    {
        redrawCanvas();
    }
}

function transformSvg(svgElement)
{
    var paths = svgElement.select(
        "rect,circle,ellipse,line,polyline,polygon,path,text"
    ).members;
    var boundingBox = svgElement.bbox();
    svgElement.style({ fill: "#FFFFFF", stroke: "#000000", "stroke-width": "0.5" });
    for (i = 0; i < paths.length; ++i)
    {
        paths[i].style({ fill: "#000000", stroke: "none", "stroke-width": "1", "vector-effect": "non-scaling-stroke" });
    }
    charm['boundingBox'] = boundingBox;
    var scale = boundingBox.width / charm.displayWidth;
    svgElement.size(charm.displayWidth, charm.displayHeight);
    svgElement.viewbox(
        boundingBox.x - charm.displayWidth * scale / 2 + boundingBox.width / 2,
        boundingBox.y - charm.displayHeight * scale / 2 + boundingBox.height / 2,
        charm.displayWidth * scale,
        charm.displayHeight * scale
    );
    var zoom = svgElement.viewbox().zoom;
    var bbox = {};
    bbox.w = boundingBox.w * zoom;
    bbox.width = boundingBox.width * zoom;
    bbox.h = boundingBox.h * zoom;
    bbox.height = boundingBox.height * zoom;
    bbox.x = boundingBox.x * zoom;
    bbox.y = boundingBox.y * zoom;
    return bbox;
}

/*
 * Set the font and redraw the canvas if necessary
 */
function updateFont(fontName)
{
    if (fontName != "")
    {
        canvasFontName = fontName;
        canvasFontSize = availableFonts[fontName]["fontSize"];
        canvasFont = "bold " + canvasFontSize  + "px '" + fontName + "'";
        if (document.getElementById('text-input').value != "" || drawnText != "")
        {
            drawInputText();    
        }
    }
}

/*
 * Append a hidden div to the body to load in the font before drawing
 */
function preloadFont(fontName)
{
    var div = document.createElement("div");
    div.setAttribute("style", "position: absolute; width: 0; height: 0; font-size: 0px; font-family: '" + fontName + "'");
    div.innerHTML = 'm';
    document.body.appendChild(div);
}

function drawInputText()
{
    var input = document.getElementById('text-input');
    renderTextPreview(input.value);
}

/*
 * Build the font dropdown from fonts listed in textjewelryconfig.js
 */
function generateFontInput()
{
    var inputElement = document.getElementById('font-input');
    Object.keys(availableFonts).forEach(function (fontName, index)
    {
        preloadFont(fontName);
        var option = document.createElement('option');
        option.value = fontName;
        option.innerHTML = availableFonts[fontName]['displayName'];
        if (index == 0)
        {
            option.setAttribute('selected', true);    
        }
        inputElement.appendChild(option);
    });
}

function generateCharmInput()
{
    var inputElement = document.getElementById('charm-input');
    var option = document.createElement('option');
    option.value = "No shape";
    option.innerHTML = "No shape";
    option.setAttribute('selected', true);
    inputElement.appendChild(option);
    Object.keys(charms).forEach(function (charmName)
    {
        option = document.createElement('option');
        option.value = charmName;
        option.innerHTML = charmName;
        inputElement.appendChild(option);
    });
}

function createDxf()
{
    var dxfConversionUrl = "https://www.oblouk.com/JewelryUtilities/convert.php";
    var args = "--tight";
    var canvasScale = 5; // upscale the canvas for a cleaner SVG
    var scaledCanvas = document.createElement('canvas');
    scaledCanvas.height = canvasScale * textCanvas.height;
    scaledCanvas.width = canvasScale * textCanvas.width;
    var scaledContext = scaledCanvas.getContext('2d');
    scaledContext.drawImage(textCanvas, 0, 0, scaledCanvas.width, scaledCanvas.height);
    var imgOut = scaledCanvas.toDataURL("image/png");
    var box = getBoundingBox(textContext, 0, 0, textCanvas.width, textCanvas.height);
    var height = box['bottom'] - box['top'] + "pt";
    jQuery.post(dxfConversionUrl, { "file": imgOut, "fileType": "svg", "height": height, "args": args}, function(response)
	{
        try
        {
            var svg = window.atob(response);
        }
        catch (error)
        {
            if (error instanceof DOMException)
            {
                console.error(response);    
            }
            else
            {
                console.error(error);    
            }
            return;
        }
        document.getElementById("outputSvg").innerHTML = svg;
        jQuery.post(dxfConversionUrl, { "file": imgOut, "fileType": "dxf", "height": height, "args": args}, function(response)
        {
            var buyer = document.getElementById('buyer-name');
            var fileName;
            if(buyer && buyer.value != '')
            {
                fileName = buyer.value + "_text.dxf";
            }
            else
            {
                fileName = "text_" + Date.now() + ".dxf";
            }
            document.getElementById('svg-link').setAttribute('download', fileName);
            document.getElementById('svg-link').setAttribute('href', "data:application/dxf;base64," + response);
            document.getElementById('svg-link').click();
        });
    });
}

/*
 * Test the current font to ensure that it can be displayed correctly for all letters
 */
function testFontShift()
{
	var characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    console.log("Testing " + canvasFontName);
    for(var i = 0; i < characters.length; ++i)
    {
    	for(var j = 0; j < characters.length; ++j)
        {
    	    var shift = getCharacterShift(characters[i], characters[j]);
            if(shift === false)
            {
                console.log("FAILED: " + characters[i] + characters[j]);
            }
    	}
  	}
    console.log("Complete");
}

var rerenderTimeout;
function startRerenderCountdown()
{
	clearRerenderCountdown();
	rerenderTimeout = setTimeout(drawInputText, 500); 
}

function clearRerenderCountdown()
{
  clearTimeout(rerenderTimeout);
}

function drawMaterialImage(canvas, material)
{
    var context = canvas.getContext('2d');
    var materialImage;
    switch (material)
    {
        case ("Gold Filled"):
            materialImage = materialImageGold;
            break;
        case ("Rose Gold Filled"):
            materialImage = materialImageRoseGold;
            break;
        case ("Silver"):
            materialImage = materialImageSilver;
            break;
        default:
            materialImage = materialImageGold;
    }
    context.drawImage(materialImage, 0, 0, canvas.width, canvas.height);
}

function drawMaterialWithEffects(canvas, material)
{
    var context = canvas.getContext('2d');
    var highlightDistanceX = -2;
    var highlightDistanceY = -1;
    var highlightBlur = 2;
    var highlightColor;
    if(material.includes("Rose"))
    {
        highlightColor = "rgba(255, 255, 255, 0.43)";
    }
    else
    {
        highlightColor = "rgba(255, 255, 255, 0.43)";
    }
    var highlightOffsetX = 3;
    var highlightOffsetY = 2;
    var lowlightOffsetX = 2;
    var lowlightOffsetY = 1;
    var lowlightBlur = .5;
    var lowlightColor = "rgba(20, 20, 20, .9)";
    var shadowOffsetX = 1;
    var shadowOffsetY = 1;
    var shadowBlur = 0;
    var shadowColor = "rgba(0, 0, 0, 0.0)";
    // Draw the material image, using the design as a mask
    context.globalCompositeOperation = 'source-in';
    drawMaterialImage(canvas, material);
    context.globalCompositeOperation = 'source-atop';
    // Draw the highlight as a drop shadow, shifted slightly, using the existing drawing as a mask
    //context.filter = "drop-shadow(" + highlightDistanceX + "px " + highlightDistanceY + "px " + highlightBlur + "px " + highlightColor + ")";
    //context.drawImage(canvas, highlightOffsetX, highlightOffsetY);
    context.globalCompositeOperation = 'destination-over';
    // Draw the hard shadow / lowlight
    context.filter = "drop-shadow(0px " + lowlightOffsetY + "px " + lowlightBlur + "px " + lowlightColor + ")";
    context.drawImage(canvas, 0, 0);
    context.filter = "drop-shadow(" + lowlightOffsetX + "px " + lowlightOffsetY + "px " + lowlightBlur + "px " + lowlightColor + ")";
    context.drawImage(canvas, 0, 0);
    // Draw the soft shadow
    //context.filter = "drop-shadow(" + shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor + ")";
    //context.drawImage(canvas, 0, 0);
    // Reset the filter
    context.filter = "drop-shadow(0px 0px 0px transparent)";
    context.globalCompositeOperation = "source-over";
}

function getMaterial()
{
    var title = $("meta[property='og:title']").attr("content");
    var titlePattern = /Custom ([^N]*) Name/;
    var match = titlePattern.exec(title);
    if (match)
    {
        return match[1];
    }
    return "Gold Filled"
}

function distance(x1, y1, x2, y2)
{
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}

function handleCanvasMouseDown(e)
{
    e.preventDefault();
    if (!isCharmEnabled) return;
    var clientX, clientY;
    if (e.type == 'mousedown')
    {
        clientX = e.clientX;
        clientY = e.clientY;
    }
    else if (e.type == 'touchstart')
    {
        
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
    }
    var rect = textCanvas.getBoundingClientRect();
    var x = (clientX - rect.left) / (textCanvas.clientWidth / textCanvas.width);
    var y = (clientY - rect.top) / (textCanvas.clientHeight / textCanvas.height);
    if (!Object.keys(savedCanvasData).includes("charm") && savedCanvasData.charm != {})
    {
        // Charm hasn't been placed
        isDraggingCharm = true;
        isCharmSelected = true;
        placeCharm(x, y);
    }
    else if (isCharmSelected && Math.abs(distanceToCharmCircle(x, y)) < 9)
    {
        isRotatingCharm = true;
        rotateStartX = x;    
        rotateStartY = y;
    }
    else if (pointIsInCharm(x, y))
    {
        isDraggingCharm = true;
        isCharmSelected = true;
        redrawCanvas();
        //placeCharm(x, y);
    }
    else
    {
        isCharmSelected = false;
        redrawCanvas();
    }
    // var point = getClosestPointOnWord(textContext, x, y, 1, 1);
    // textContext.fillStyle = "#FF00FF";
    // textContext.fillRect(point.x - 1, point.y - 1, 3, 3);
}

function handleCanvasMouseMove(e)
{
    e.preventDefault();
    if (!isCharmEnabled) return;
    var clientX, clientY;
    if (e.type == 'mousemove')
    {
        clientX = e.clientX;
        clientY = e.clientY;
    }
    else if (e.type == 'touchmove')
    {
        
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
    }
    var rect = textCanvas.getBoundingClientRect();
    var x = (clientX - rect.left) / (textCanvas.clientWidth / textCanvas.width);
    var y = (clientY - rect.top) / (textCanvas.clientHeight / textCanvas.height);
    if (isDraggingCharm)
    {
        placeCharm(x, y);
        textCanvas.style.cursor = "move";
    }
    else if (isRotatingCharm)
    {
        rotateCharm(x, y);
        textCanvas.style.cursor = "move";
    }
    if (isCharmSelected && distanceToCharmCircle(x, y) < 9)
    {
        textCanvas.style.cursor = "pointer"; 
    }
    else if (pointIsInCharm(x, y))
    {
        textCanvas.style.cursor = "move";    
    }
    else
    {
        textCanvas.style.cursor = "auto";    
    }
}

function handleCanvasMouseUp(e)
{
    isDraggingCharm = false;
    isRotatingCharm = false;
}

function init()
{
  	//populateDeliverDate();
    var domains = ['rachelrothjewelry.com', 'everynamenecklace.com', 'every-name-necklace.myshopify.com', 'shopifypreview.com', 'localhost'];
    for (var i = 0; i < domains.length; ++i)
    {
        if (window.location.href.includes(domains[i])) break;
        if (i == domains.length - 1) return;
    }
    isAdmin = window.location.href.toLowerCase().includes("admin");
    if(isAdmin) canvasFontColor = "#000000"; 
    overlay = new Image();
    overlay.crossOrigin = 'Anonymous';
    var overlayLoaded = false;
    var materialLoaded = false;
    var maxRotateDistance = 10;
    overlay.onload = function ()
    {
        overlayLoaded = true;
        if (materialLoaded)
        {
            setTimeout(function ()
            {
                updateFont(document.getElementById('font-input').value);
            }, 500);
        }
    };
    textCanvas = document.getElementById('text-canvas');
    textContext = textCanvas.getContext('2d');
    if (typeof(charms) != "undefined" && document.getElementById('charm-input'))
    {
        charm = {};   
        if (!isAdmin)
        {
            textCanvas.addEventListener("mousedown", handleCanvasMouseDown);
            textCanvas.addEventListener("mousemove", handleCanvasMouseMove);
            textCanvas.addEventListener("mouseup", handleCanvasMouseUp);
            textCanvas.addEventListener("touchstart", handleCanvasMouseDown);
            textCanvas.addEventListener("touchmove", handleCanvasMouseMove);
            textCanvas.addEventListener("touchend", handleCanvasMouseUp);
        }
        window.addEventListener("keydown", function (e)
        {
            if (e.keyCode == 16)
            {
                shiftIsHeld = true;    
            }
        });
        window.addEventListener("keyup", function (e)
        {
            
            if (e.keyCode == 16)
            {
                shiftIsHeld = false;    
            }
        });
        this.generateCharmInput();
    }
    charCanvas = document.getElementById('character-staging-canvas');
    charContext = charCanvas.getContext('2d'); 
    this.materialImageGold = new Image();
    this.materialImageGold.crossOrigin = 'Anonymous';
    this.materialImageGold.src = "//rachelrothjewelry.com/cdn/shop/t/15/assets/metalgold.png?v=182821291138318242471790550100";
    this.materialImageRoseGold = new Image();
    this.materialImageRoseGold.crossOrigin = 'Anonymous';
    this.materialImageRoseGold.src = "//rachelrothjewelry.com/cdn/shop/t/15/assets/metalrose.png?v=32010796327207632231790550100";
    this.materialImageSilver = new Image();
    this.materialImageSilver.crossOrigin = 'Anonymous';
    this.materialImageSilver.src = "//rachelrothjewelry.com/cdn/shop/t/15/assets/metalsilver.png?v=28297475176322367551790550100";
    this.materialImageSilver.onload = function ()
    {
        materialLoaded = true;
        setTimeout(function ()
        {
            updateFont(document.getElementById('font-input').value)
        }, 500);
    }
  	window.addEventListener('keydown', function(e) {
    	if(e.keyCode == 13 && document.activeElement.id == 'text-input')
        {
            // Do not submit the form if the user hits enter
          	e.preventDefault();
          	document.activeElement.blur()
        }
    });
    this.generateFontInput();
    overlay.src = overlaySource;
}

window.onload = init;
